import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Feedback from '../../../../../../components/mui/Feedback';
import FormComponent from './FormComponent';
import DeleteComponent from './DeleteComponent';
import { setFormData, setFormType, setIsOpenModal, setIsLoadingShow, setIsLoadingForm } from '../redux/actions/commercialStatusAction';
import usePermission from '../../../../../../hooks/usePermission';
import { initialValuesCommercialStatus as initialValues } from '../../../../../../helpers/variablesInitialValues';

const ModalComponent = () => {
	const dispatch = useDispatch();
	const isOpenModal = useSelector( ({ commercialStatus }) => commercialStatus.isOpenModal);
	const formType = useSelector( ({ commercialStatus }) => commercialStatus.formType);
	const permissionStore = usePermission('commercialStatus.store');
	const permissionShow = usePermission('commercialStatus.show');
	const permissionDelete = usePermission('commercialStatus.delete');
	
	/**
	 *
	 * @description Execute reset formData, loading show, loading form, close modal state
	 * @return dispatch
	 *
	 */
	const handleCloseModal = async () => {
		await dispatch( setFormData(initialValues) );
		await dispatch( setFormType('') );
		await dispatch( setIsLoadingShow(false) );
		await dispatch( setIsLoadingForm(false) );
		await dispatch( setIsOpenModal(false) );
	};
	
	return (
		<Feedback.Modal
			maxWidth="md"
			isOpen={isOpenModal}
			isClose={handleCloseModal}
			title={formType === 'delete' ? `Eliminación del estatus comercial` : 'Captación de estatus comerciales'}
		>
			{(formType === 'store' || formType === 'show') && (
				(formType === 'store' ? permissionStore : permissionShow) && (
					<FormComponent />
				)
			)}
			{formType === 'delete' && (
				permissionDelete && (
					<DeleteComponent />
				)
			)}
		</Feedback.Modal>
	);
};

export default ModalComponent;
